import { Component, OnInit } from '@angular/core';

import { fuseAnimations } from '@fuse/animations';
import * as XLSX from 'xlsx';
import * as colabInter from './colaboradores-v2.interfaces';
import * as backInter from 'app/auth/auth-data.model';
import { ColaboradoresService } from 'app/main/wizard-cgo/services/colaboradores.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_secciones } from 'app/idiomas/i18n/Izzi/izzisecciones/izzisecciones.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_modales_izzi } from 'app/idiomas/i18n/Izzi/izzimodales/izzimodales.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { EnvioService } from 'app/main/wizard-cgo/services/envio.service';
import { SurveyCheckComponent } from "app/main/pagina/productos/certificar/tipo_1/programacion/vista-gen/survey-check/survey-check.component";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { zonasUTC } from 'app/main/pagina/zonasUtc';

type AOA = any[][];

import { DATOS_API } from 'app/auth/auth.datos';

const moment = require('moment');
const momentTz = require('moment-timezone');

@Component({
  selector: 'app-colaboradores-v2',
  templateUrl: './colaboradores-v2.component.html',
  styleUrls: ['./colaboradores-v2.component.scss'],
  animations : fuseAnimations
})
export class ColaboradoresV2Component implements OnInit {

  urlAssets = DATOS_API.urlAssets;

  cargando = true;
  cargandoBD = false;
  guardandoBD = false;
  stored = false;
  colabsEnBD = 0;
  fechaCarga:string;

  idiomaActual:string;
  instituto: string;
  nombreEmpresa: string;

  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';

  charIdiomas = this.charChinos + this.charTurcos;

  regexAlfabetico = new RegExp("^[" + this.charIdiomas + "a-zA-Z  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
  regexAlfanumerico = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
  regexNumerico = new RegExp("^[0-9]+$");
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

  data: AOA = [];
  files: any = [];

  totRows = 0;

  filaInicial: number;

  arregloColaboradores: colabInter.Colaborador[] = [];
  errores:colabInter.errorEncontrado[] = [];
  erroresTotales = 0;

  nombresColumnas: string[] = [];
  clavesColumnas: string[] = [];
  nombresColumnasBD = {} as colabInter.Colaborador;

  columnasObligatorias: any[] = colabInter.COLUMNAS_OBLIGATORIAS;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;

  //id idioma nativo
  idLangNativo: string;
  // tipos demograficos guardados
  // tiposDemograficos: backInter.allDemograficos;
  tiposDemograficos: any[] = [];

  //opciones demograficas
  opcionesDemograficas: any[] = [];

  claveAge = 'Age';
  claveGender = 'Gender';
  claveTOW = 'Type of work';
  claveWC = 'Work condition';
  claveAntiq = 'Antiquity';
  actualizadoUsuario=false;

  //claves random surveykeyhk
  skhk: any[] = [];

  //boolean ceo encontrado
  ceoEncontrado = false;

  //boolean paso completo
  pasoCompleto = false;

  //libreria moment
  moment = require('moment');

  //version nueva excel
  versionNueva: boolean;

  datosSurveyCheck:any;
  token:any;

  userData:any;
  validationUser:boolean=false;
  validationSurvey:boolean=false;
  desbloqueoEstatus:boolean=false;


  //zonas horarias
  zonasUTC = zonasUTC;
  idiomaUtc: string;
  instUtc: number;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;

  constructor(
    private encuestaService: EncuestaService,
    private colaboradoresService: ColaboradoresService,
    private wizardService: WizardService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private programacionService:ProgramacionService,
    private envioService: EnvioService,

  ) {
    if(localStorage.getItem('tipoIzzi')){
    lang_secciones.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales_izzi.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    }
    else{
      lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });

      lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
    }
    lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    //obtiene id instituto
    this.obtieneInstituto();

    if(localStorage.getItem('userBypass')){
    this.userData=JSON.parse(localStorage.getItem('userBypass'));
    // console.log(this.userData.level);
    if(this.userData.level==3 || this.userData.level==2){
      this.validationUser=true;
    }
    else{
      this.validationUser=false;
    }
    }
  }

  ngOnInit() {
    this.obtieneCertificarActual();
  }

  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; this.instUtc = 1;  break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; this.instUtc = 2;  this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_CAYC; break;
      case '3': case 'HK': this.instituto = 'HK'; this.instUtc = 3;  this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_HK; break;
      case '4': case 'SGP': this.instituto = 'WLDWDE'; this.instUtc = 4;  break;
      case '5': case 'TK': this.instituto = 'TK'; this.instUtc = 5;  this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_TK; break;
      case '6': case 'FL': this.instituto = 'WLDWDE'; this.instUtc = 6;  break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; this.instUtc = 1;  break;
      case '11': case 'BR': this.instituto = 'WLDWDE'; this.instUtc = 11;  break;
      case '14': case 'GCTI': this.instituto = 'GCTI'; this.instUtc = 1;  break;
      case '15': case 'ES': this.instituto = 'WLDWDE'; this.instUtc = 15;  break;
      default: this.instituto = 'WLDWDE';
    }
    //se coloca aqui porque dentro de esa funcion se requiere tener el instituto
    this.traduceTextosTS();
    //calculo de zona utc
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instUtc);
    this.calculoOffsetPipe();
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
        prodsCertificar.forEach( (producto) => {
          let fecha = producto.fechaCertificar;
          let idProducto = producto.idCertificar;
          if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
            this.productoCertificar = producto;
            this.token=producto.tokenConfig;
            this.getStatusEncuesta(this.token);
            this.getEstatusDesbloqueo();
            this.getEstatusEnvioCorreos();
            // this.surveyCheckService();
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.colaboradoresService.getStatusColaboradores(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
        this.pasoCompleto = true;

      });
      //obtiene los colaboradores guardados y fecha de carga
      this.getColaboradoresFast();
      //status de modal informativo
      this.getStatusModal();

      //obtiene nombre empresa
      this.wizardService.getInfoEmpresa().subscribe((data:backInter.infoEmpresa) => {
        this.nombreEmpresa = data.data.nombreEmpresa;
      });
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  envioCorreo:boolean=false;
  getEstatusEnvioCorreos(){
    this.envioService.getEstatusEnvioCorreo().subscribe( (data: any) => {
      console.log(data);
      this.envioCorreo=data.envioCorreos;
    });
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoCertificar.idCertificar).subscribe((respuesta:any) => {
      // console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  getStatusEncuesta(token:any){
  if(token){
    this.wizardService.getStatusEncuesta(token).subscribe( (data:any) => {
      // console.log(data);
      if(data.result.id_status==1){
        this.validationSurvey=true;
      }
      else{
        this.validationSurvey=false;
      }
    });
  }
  }

  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      colaboradores: 1
    };
    console.log(datos);
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
        this.modalInformativo('COLABORADORES');
      }
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      colaboradores: 2
    };
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {});
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,

      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

  ModalArchivo(){
    let botonModalArchivo = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.ARCHIVOCOMFIRM';
    this.translateSrv.get(botonModalArchivo).subscribe((res: string) => { botonModalArchivo = res; });
    let rspEnterado = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspEnterado).subscribe((res: string) => { rspEnterado = res; });
    Swal.fire({
      title: botonModalArchivo,
      icon: 'warning',
      showCancelButton: false,

      confirmButtonText: rspEnterado,

    });
  }

  getColaboradoresFast(){
    this.colaboradoresService.getColaboradoresFast(this.productoCertificar.idCertificar)
    .subscribe( (getFast: colabInter.getBDFast) => {
      if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
        this.stored = true;
        this.colabsEnBD = getFast.numeroColaboradores;
        this.fechaCarga = getFast.fecha;
        console.log("Perro");
        console.log(this.fechaCarga);
      }
      this.cargando = false;
    });
  }

  traduceTextosTS(){
    this.idiomaUtc = this.translateSrv.currentLang;
    switch(this.translateSrv.currentLang){
      case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
      case 'zh1': case 'zh2':
        if(this.instituto == 'HK'){
          this.idiomaActual = this.translateSrv.currentLang;
        }
        else{
          this.idiomaActual = 'en';
        }
      break;
      case 'tr':
        if(this.instituto == 'TK'){
          this.idiomaActual = this.translateSrv.currentLang;
        }
        else{
          this.idiomaActual = 'en';
        }
      break;
      default: this.idiomaActual = 'en';
    }
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  infoError(detalleError:string){
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    Swal.fire({
      title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.CARD_ERRLIST.DESCRIPCION.'+detalleError),
      icon: 'warning',
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  deleteAttachment(index?:number, origen?:boolean) {
    if(origen){
      Swal.fire({
        title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DELFILE'),
        icon: 'success',
        confirmButtonColor: '#e40601'
      });
    }
    this.files = [];
    this.data = [];
    this.arregloColaboradores = [];
    this.errores = [];
    this.erroresTotales = 0;
    this.nombresColumnas = [];
    this.clavesColumnas = [];
    this.stored = false;
    this.colabsEnBD = 0;
    this.fechaCarga = null;
    this.totRows = 0;
  }

  ////LEER XLSM
  onFileChange(evt: any) {
    this.versionNueva = false;
    this.cargandoBD = true;
    let fec1 = new Date();
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    if(colabInter.FORMATO_ADMITIDO.includes(target.files[0].type)){
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

        if(wb.SheetNames.includes("Referencias") || wb.SheetNames.includes("Version")){
          /* grab first sheet */
          let numeroHojaALeer = 0;
          const wsname: string = wb.SheetNames[numeroHojaALeer];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          /* save data */
          this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));

          // console.log("data:",this.data);
          // console.log("wb:",wb);
          // console.log("ws:",wb.Sheets);
          // console.log("wsn:",wb.SheetNames);

          if(wb.SheetNames.includes("Version")){
            this.versionNueva = true;
          }

          let conRegistros: boolean;
          let numColumnas: number;

          if(this.versionNueva){
            console.log("analisis version nueva");

            if(this.data.length > 3){ //si hay mas de tres filas (fila boton, fila instrucciones y fila nombres columnas)
              conRegistros = true;
              numColumnas = this.data[2].length;
              this.filaInicial = 3;
              console.log("numero de columnas:"+numColumnas);
              // console.log("columnas:",this.data[2]);
              this.nombresColumnas = this.data[2];

              let indiceReferencias: number;
              switch(this.instituto){
                case 'MX': indiceReferencias = wb.SheetNames.indexOf("Referencias_MX"); break;
                case 'CAyC': indiceReferencias = wb.SheetNames.indexOf("Referencias_CAYC"); break;
                case 'HK': indiceReferencias = wb.SheetNames.indexOf("Referencias_HK"); break;
                case 'TK': indiceReferencias = wb.SheetNames.indexOf("Referencias_TR"); break;
                case 'BR': indiceReferencias = wb.SheetNames.indexOf("Referencias_MX"); break;
                case 'GCTI': indiceReferencias = wb.SheetNames.indexOf("Referencias_MX"); break;
                default:  indiceReferencias = wb.SheetNames.indexOf("Referencias_WWDE");
              }

              //parche referencias ingles
              if(indiceReferencias == -1){
                switch(this.instituto){
                  case 'MX': indiceReferencias = wb.SheetNames.indexOf("References_MX"); break;
                  case 'CAyC': indiceReferencias = wb.SheetNames.indexOf("References_CAYC"); break;
                  case 'HK': indiceReferencias = wb.SheetNames.indexOf("References_HK"); break;
                  case 'TK': indiceReferencias = wb.SheetNames.indexOf("References_TR"); break;
                  case 'BR': indiceReferencias = wb.SheetNames.indexOf("References_MX"); break;
                  case 'GCTI': indiceReferencias = wb.SheetNames.indexOf("References_MX"); break;
                  default:  indiceReferencias = wb.SheetNames.indexOf("References_WWDE");
                }
              }

              // console.log("indiceRef:",indiceReferencias);
              if(indiceReferencias != -1){
                const hojaRef: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[indiceReferencias]];
                const datosHojaRef = <AOA>(XLSX.utils.sheet_to_json(hojaRef, {header: 1}));
                // console.log("datosHojaRef:",datosHojaRef);

                let BreakException = {};
                try {
                  datosHojaRef.forEach((fila,i) => {
                    if(fila[0] != null){  //si hay informacion en la celda A continua, si no se detiene el foreach
                      if(i > 0){  //si el iterador es mayor a 0 (a partir de la segunda fila)
                        if(fila[0] == 1){   //si el status es 1 (columna habilitada)
                          this.clavesColumnas.push( hojaRef['R'+(i+1)].v.split(",")[0] );
                        }
                      }
                    }
                    else throw BreakException;
                  });
                } catch (e) {
                  if (e !== BreakException) throw e;
                };

                // console.log("nombresColumnas:",this.nombresColumnas);
                // console.log("clavesColumnas:",this.clavesColumnas);
              }
              else{
                this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
                this.cargandoBD = false;
                console.log("trono aqui :V");
              }
            }
            else{
              this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.NOROWS'), 3); //mensaje de sin filas de colaboradores
              this.cargandoBD = false;
            }
          }
          else{
            console.log("analisis version anterior");

            if(this.data.length > 2){ //si hay mas de dos filas (la primera donde está el boton de validar y la de nombres de columnas)
              conRegistros = true;
              numColumnas = this.data[1].length;
              this.filaInicial = 2;
              console.log("numero de columnas:"+numColumnas);

              let BreakException = {};
              try {
                this.data[1].forEach((nombreCol, i) => {  //fila de nombres de columnas
                  this.nombresColumnas.push(nombreCol);
                  let infoCeldaNombre = wb.Sheets[wsname][colabInter.LETRAS[i]+'2'];
                  if(infoCeldaNombre.c){
                    let claveColumaArr = infoCeldaNombre.c[0].t.split("|");
                    this.clavesColumnas.push(claveColumaArr[0]);
                  }
                  else{
                    conRegistros = false;
                    throw BreakException;
                  }
                });
              } catch (e) {
                  if (e !== BreakException) throw e;
              };
            }
            else{
              this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.NOROWS'), 3); //mensaje de sin filas de colaboradores
              this.cargandoBD = false;
            }
          }

          if(conRegistros){
            this.nombresColumnasExcel(numColumnas);

            let BreakException = {};
            try {
              this.data.forEach( (fila,i) => {  //ciclo que recorre las filas del archivo
                if(i >= this.filaInicial){  // se salta las lineas de instrucciones y nombres de columnas
                  if(fila[0] != null){
                    this.validacionCelda(fila, (i+1), numColumnas);  //datos de la fila, numero real de fila, numero de columna
                  }
                  else{
                    throw BreakException;
                  }
                }
              });
            } catch (e) {
              if (e !== BreakException) throw e;
            };

            this.paridadBosskey();
            this.continuidadNiveles();

            //si no encontró el CEO, agrega un error de ceo no encontrado
            if(!this.ceoEncontrado){
              this.errores.push({
                numeroFila: 1,
                datos: '',
                listaErrores: [{
                  numeroColumna: '',
                  columna: '',
                  dato: '',
                  tipoError: 'noCeo'
                }]
              });
              this.erroresTotales++;
            }

            this.cargandoBD = false;
            let fec2 = new Date();
            let fx = (fec2.getTime() - fec1.getTime()) / 1000;

            console.log("registros cargados: "+this.arregloColaboradores.length);
            console.log("tiempo de carga de bd en front: "+fx+" segs");
            // console.log("valor final de barporcen: "+this.barPorcen);

            let arcs = evt.target.files
            for (let index = 0; index < arcs.length; index++) {
              const element = arcs[index];
              // console.log(element);
              this.files.push(element.name)
            }
          }
          else{
            this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
            this.cargandoBD = false;
            console.log("trono aqui :V");
          }
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
          this.cargandoBD = false;
          console.log("trono aqui :V");
        }
      };
      reader.readAsBinaryString(target.files[0]);
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL'), 3); //mensaje de extensión incorrecta
      this.cargandoBD = false;
      console.log("trono aqui :V");
    }
  }

  nombresColumnasExcel(numColumnas:number){
    // let this.nombresColumnasBD = {} as colabInter.nombresColumnasEnBD;
    this.nombresColumnasBD.productoId = this.productoCertificar.idCertificar;
    for(let i=0;i<numColumnas;i++){
      this.nombresColumnasBD[this.clavesColumnas[i]] = this.nombresColumnas[i];
    }
    if(this.instituto == 'HK' || this.instituto == 'TK'){ //si es instituto hk o tr se agrega la columna surveykey, no viene en el excel
      this.nombresColumnasBD.surveyKey = 'Survey Key';
    }
    // console.log(this.nombresColumnasBD);
  }

  validacionCelda(datosFila:any, numFila:number, numColumnas:number){
    let listaErrores: colabInter.listaErrores[] = [];
    let filaCeo: boolean;
    let ownKey: string;
    let bossKey: string;

    for (let i = 0; i < numColumnas; i++) { // CICLO PARA BUSCAR EL CEO Y LA OWNKEY
      //SE IDENTIFICA AL CEO
      if(this.clavesColumnas[i] == 'ownKey'){
        ownKey = datosFila[i];
      }
      if(this.clavesColumnas[i] == 'bossKey'){
        bossKey = datosFila[i];
        if(datosFila[i] == 0){
          console.log("ceo:",datosFila);
          filaCeo = true;
          this.ceoEncontrado = true;
        }
      }
    }

    for(let i=0;i<numColumnas;i++){

      let errorFnd = false;
      let indiceCol = colabInter.CLAVES_COLUMNAS.findIndex(item => item.clave === this.clavesColumnas[i]);
      if(indiceCol != -1){

        let tipoValidacion = colabInter.CLAVES_COLUMNAS[indiceCol].validacion;
        switch(tipoValidacion){
          case 'alfabetica':
            if(datosFila[i]){
              datosFila[i].toString().trim();
            }
            if(!this.validacionAlfabetica(datosFila[i])){
              errorFnd = true;
            }
          break;
          case 'alfanumerica':
          if(!this.validacionAlfanumerica(datosFila[i])){
            errorFnd = true;
          }
          break;
          case 'numerica':
          if(!this.validacionNumerica(datosFila[i])){
            errorFnd = true;
          }
          break;
          case 'email':
          datosFila[i].trim();
          if(!this.validacionEmail(datosFila[i])){
            errorFnd = true;
            if(datosFila[i] == "*"){
              errorFnd = false;
            }
          }
          break;
        }   //evalua el contenido de la celda de acuerdo a su tipo de validacion
        if(!errorFnd){    //si no se encontró error en la celda, se hace una segunda revisión, busca vacios y evalua columnas obligatorias
          //comprueba vacio
          if(this.columnasObligatorias.indexOf(this.clavesColumnas[i]) != -1){  //si se encontro la celda en la lista de columnas obligatorias
            let vacioFnd = false;
            // if(typeof datosFila[i] == 'number'){
            if(tipoValidacion == 'numerica'){
              if(datosFila[i] == null)
              vacioFnd = true;
            } //revisa si el tipo de dato es numerico y vaclo
            else{
              if(datosFila[i] != null){
                if(datosFila[i].length == 0){
                  if(filaCeo && this.clavesColumnas[i] == 'bossKey' || filaCeo && this.clavesColumnas[i] == 'bossName'){
                    vacioFnd = false;
                  }
                  else{
                    vacioFnd = true;
                  }
                }
              }
              else{
                if(filaCeo && this.clavesColumnas[i] == 'bossKey' || filaCeo && this.clavesColumnas[i] == 'bossName'){
                  vacioFnd = false;
                }
                else{
                  vacioFnd = true;
                }
              }
            } //revisa si el tipo de dato es string y vacio
            if(vacioFnd){   //si encontró la celda vacia, agrega un error de celda vacia
              listaErrores.push({
                numeroColumna: colabInter.LETRAS[i],
                columna: this.nombresColumnas[i],
                dato: datosFila[i],
                tipoError: 'vacio'
              });
              this.erroresTotales++;
            }
            else{
              if(colabInter.COLUMNAS_NO_REPETIR.indexOf(this.clavesColumnas[i]) != -1){   //si la celda no estaba vacia, se busca si pertenece a una columna que prohibe repetidos
                if(this.buscaRepetidos(datosFila[i],this.clavesColumnas[i],numColumnas)){
                  if(this.clavesColumnas[i] == "email" && datosFila[i] == "*"){
                    //no agregar error
                  }
                  else{
                    listaErrores.push({
                      numeroColumna: colabInter.LETRAS[i],
                      columna: this.nombresColumnas[i],
                      dato: datosFila[i],
                      tipoError: 'repetido'
                    });
                    this.erroresTotales++;
                  }
                }
              }
              else if(this.clavesColumnas[i] == 'bossKey'){ //si un colaborador tiene como bosskey su propia clave, se guarda un error
                if(datosFila[i] == ownKey){
                  listaErrores.push({
                    numeroColumna: colabInter.LETRAS[i],
                    columna: this.nombresColumnas[i],
                    dato: datosFila[i],
                    tipoError: 'sameKey'
                  });
                  this.erroresTotales++;
                }
              }
            }
          }
        }
        else{
          if(this.columnasObligatorias.indexOf(this.clavesColumnas[i]) != -1){
            listaErrores.push({
              numeroColumna: colabInter.LETRAS[i],
              columna: this.nombresColumnas[i],
              dato: datosFila[i],
              tipoError: tipoValidacion
            });
            this.erroresTotales++;
          }
        }
      }
      else{
        //crear error de columa no encontrada
        listaErrores.push({
          numeroColumna: colabInter.LETRAS[i],
          columna: this.nombresColumnas[i],
          dato: datosFila[i],
          tipoError: 'columna'
        });
        this.erroresTotales++;
      }
    }
    //Si al terminar el ciclo de la fila la lista de errores es mayor a cero se agrega fila a array de errores
    if(listaErrores.length > 0){
      this.errores.push({
        numeroFila:numFila,
        datos: datosFila,
        listaErrores: listaErrores
      });
    }
    else{ //si no hay errores, se agrega a array de filas correctas
      this.filaCorrecta(datosFila,numColumnas);
    }
  }

  validacionAlfabetica(dato:any){
    return this.regexAlfabetico.test(dato);
  }
  validacionAlfanumerica(dato:any){
    return this.regexAlfanumerico.test(dato);
  }
  validacionNumerica(dato:any){
    return this.regexNumerico.test(dato);
  }
  validacionEmail(dato:any){
    return this.regexEmail.test(dato);
  }

  paridadBosskey(){
    let indiceOwnkey = this.clavesColumnas.indexOf('ownKey');
    let indiceBosskey = this.clavesColumnas.indexOf('bossKey');
    let erroresBosskey: any[] = [];
    this.data.forEach( (filaBoss,i) => {  //ciclo que recorre las filas del archivo
      if(i >= this.filaInicial){  // se salta las lineas de instrucciones y nombres de columnas
        if(filaBoss[0] != null){
          if(filaBoss[indiceBosskey] != 0){
            let encontrado = false;
            let BreakException2 = {};
            try {
              this.data.forEach( (filaOwn,j) => {  //ciclo que recorre las filas del archivo
                if(j >= this.filaInicial){  // se salta las lineas de instrucciones y nombres de columnas
                  if(filaOwn[0] != null){
                    if(filaBoss[indiceBosskey] === filaOwn[indiceOwnkey]){
                      encontrado = true;
                      throw BreakException2;
                    }
                  }
                }
              });
            } catch (e) {
              if (e !== BreakException2) throw e;
            };
            if(!encontrado){

              let datosError = {
                numeroColumna: colabInter.LETRAS[indiceBosskey],
                columna: this.nombresColumnas[indiceBosskey],
                dato: filaBoss[indiceBosskey],
                tipoError: 'bosskeyNotFnd'
              };

              let indiceError = this.errores.findIndex(item => item.numeroFila == (i+1));
              if(indiceError != -1){
                this.errores[indiceError].listaErrores.push(datosError);
              }
              else{
                this.errores.push({
                  numeroFila: (i+1),
                  datos: filaBoss,
                  listaErrores: [datosError]
                });
              }
            }
          }
        }
      }
    });
  }

  continuidadNiveles(){
    let nivGeo: any[] = [];
    let nivStr: any[] = [];

    this.clavesColumnas.forEach((columna,i) => {
      if(columna.includes("geo_")){
        nivGeo.push({
          indice: i,
          nombre: columna
        });
      }
      if(columna.includes("structure_")){
        nivStr.push({
          indice: i,
          nombre: columna
        });
      }
    });
    console.log("nivelesGeo:",nivGeo);
    console.log("nivelesStr:",nivStr);

    let BreakException = {};
    try {
      this.data.forEach( (fila,i) => {  //ciclo que recorre las filas del archivo
        if(i >= this.filaInicial){  // se salta las lineas de instrucciones y nombres de columnas
          if(fila[0] != null){
            let vacioPrevio = false;
            //recorre todos los niveles geograficos
            for (let itGeo = nivGeo[0].indice; itGeo < nivGeo[nivGeo.length-1].indice; itGeo++) {
              if(itGeo == nivGeo[0].indice){
                if(fila[itGeo] == undefined){
                  vacioPrevio = true;
                }
              }
              else{
                if(fila[itGeo] == undefined){
                  vacioPrevio = true;
                }
                else{
                  if(vacioPrevio){
                    //genera error continuidad
                    this.errorNiveles(fila[i-1], (i+1), (itGeo-1), 'continuidad');
                    vacioPrevio = false;
                  }
                  // else{
                  //   if(fila[itGeo-1] === fila[itGeo]){
                  //     //genera error repetido contiguo
                  //     this.errorNiveles(fila, (i+1), itGeo, 'nivelRepetido');
                  //   }
                  // }
                }
              }
            }
            //recorre todos los niveles estructurales
            vacioPrevio = false;
            for (let itStr = nivStr[0].indice; itStr < nivStr[nivStr.length-1].indice; itStr++) {
              if(itStr == nivStr[0].indice){
                if(fila[itStr] == undefined){
                  vacioPrevio = true;
                }
              }
              else{
                if(fila[itStr] == undefined){
                  vacioPrevio = true;
                }
                else{
                  if(vacioPrevio){
                    //genera error continuidad
                    this.errorNiveles(fila[i-1], (i+1), (itStr-1), 'continuidad');
                    vacioPrevio = false;
                  }
                  // else{
                  //   if(fila[itStr-1] === fila[itStr]){
                  //     //genera error repetido contiguo
                  //     this.errorNiveles(fila, (i+1), itStr, 'nivelRepetido');
                  //   }
                  // }
                }
              }
            }
          }
          else{
            throw BreakException;
          }
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };

  }
  errorNiveles(datos:any, numeroFila:number, indiceColumna:number, tipoError:string){
    let datosError = {
      numeroColumna: colabInter.LETRAS[indiceColumna],
      columna: this.nombresColumnas[indiceColumna],
      dato: datos[indiceColumna],
      tipoError
    };

    let indiceError = this.errores.findIndex(item => item.numeroFila == numeroFila);
    if(indiceError != -1){
      this.errores[indiceError].listaErrores.push(datosError);
    }
    else{
      this.errores.push({
        numeroFila,
        datos,
        listaErrores: [datosError]
      });
    }
  }

  buscaRepetidos(datosFila:any, clave:string, numColumnas:number){
    let repetidoEncontrado = false;
    let BreakException = {};
    try {
      this.arregloColaboradores.forEach((colaborador) => {
        if(colaborador[clave] == datosFila){
          repetidoEncontrado = true;
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    return repetidoEncontrado;
  }

  filaCorrecta(datosFila:any,numColumnas:number){
    let colaborador = {} as colabInter.Colaborador;
    colaborador.productoId = this.productoCertificar.idCertificar;
    for(let i=0;i<numColumnas;i++){
      switch(this.clavesColumnas[i]){
        case 'ownKey': case 'bossKey': case 'surveyKey':
        if(typeof datosFila[i]==='string'){
          console.log('Entro a string');
          colaborador[this.clavesColumnas[i]] = datosFila[i].toString();
        }
        else{
          console.log('Entro a number');
          if(datosFila[i] > -1) colaborador[this.clavesColumnas[i]] = datosFila[i].toString();
        }
        break;
        case 'enterDate': colaborador[this.clavesColumnas[i]] = this.fechaCorrecta(datosFila[i]); break;
        case 'native':
          if(this.versionNueva){
            colaborador[this.clavesColumnas[i]] = datosFila[i];
            colaborador.lang = this.buscaClaveIdiomaNativo(datosFila[i]);
          }
          else{
            colaborador[this.clavesColumnas[i]] = datosFila[i];
            colaborador.lang = this.buscaClaveIdiomaNativo(datosFila[i]);
          }
        break;
        case 'answer':
          colaborador.sendingType = this.buscaClaveResponde(datosFila[i]);
          colaborador[this.clavesColumnas[i]] = datosFila[i];
        break;
        default: colaborador[this.clavesColumnas[i]] = datosFila[i];
      }
    }
    if(this.instituto == 'HK' || this.instituto == 'TK'){ //si es instituto hk o tr se agrega la surveykey random
      if(!colaborador.surveyKey){
        colaborador.surveyKey = this.clavesRandom();
      }
    }
    this.arregloColaboradores.push(colaborador);
  }

  buscaClaveResponde(responde:string){
    let clave: number;
    // let BreakException = {};
    // try {
    //   lang_perfiles.forEach(idioma => {
    //     // console.log("idioma:",idioma);
    //     let encontrado = false;
    //     if(idioma.data.RESPONDE){
    //       for(let k in idioma.data.RESPONDE){
    //         if(idioma.data.RESPONDE[k] == responde){
    //           encontrado = true;
    //           clave = parseInt(k);
    //           break;
    //         }
    //       }
    //       if(encontrado) throw BreakException;
    //     }
    //   });
    // } catch (e) {
    //   if (e !== BreakException) throw e;
    // };
    clave = parseInt(responde.substr(0,2));
    // if(clave < 10){
    //   clave = 1;
    // }
    return clave;
  }

  buscaClaveIdiomaNativo(nomIdioma:string){
    let clave: string;
    // let BreakException = {};
    // try {
    //   lang_idiomas.forEach(idioma => {
    //     let encontrado = false;
    //     for(let k in idioma.data.NOMBREIDIOMAS){
    //       if(idioma.data.NOMBREIDIOMAS[k] == nomIdioma){
    //         encontrado = true;
    //         clave = k;
    //         break;
    //       }
    //     }
    //     if(encontrado) throw BreakException;
    //   });
    // } catch (e) {
    //   if (e !== BreakException) throw e;
    // };
    clave = nomIdioma.substr(0,2);
    switch (clave) {
      case "z1": clave = "zh1"; break;
      case "z2": clave = "zh2"; break;
    }
    return clave;
  }

  fechaCorrecta(fechaActual:any){
    let fechaFinal: string;
    if(isNaN(fechaActual)){
      fechaFinal = fechaActual;
    }
    else{
      let fechaInicial = "30-12-1899";
      let fechaReal = this.moment(fechaInicial, "DD-MM-YYYY");
      fechaReal.add(fechaActual, 'days');
      fechaFinal = this.moment(fechaReal).format('DD/MM/YYYY');
    }
    return fechaFinal;
  }

  clavesRandom(){
    let clave: any;
    let claveOk = false;
    do {
      clave = Math.floor(Math.random() * (999999 - 100000 + 1) ) + 100000;
      let indice = this.skhk.indexOf(clave);
      if(indice == -1){  //si no se encontro la clave
        this.skhk.push(clave);
        claveOk = true;
      }
    }
    while (!claveOk);
    return clave.toString();
  }

  guardarColaboradoresBD(){
    if(!this.pasoCompleto){
      if(this.arregloColaboradores.length > 0 && this.errores.length == 0 && this.erroresTotales == 0){
        console.log("columnas");
        console.log(this.nombresColumnasBD);
        console.log("colaboradores");
        console.log(this.arregloColaboradores);
        Swal.fire({
          title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_1') + this.arregloColaboradores.length + this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_2'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,


          confirmButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.SI'),
          cancelButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.NO')
        }).then((result) => {
          if (result.value) {
            this.guardandoBD = true;
            let inicio = new Date();
            let fin: any;
            this.colaboradoresService.guardaColaboradores(this.productoCertificar.idCertificar, this.nombresColumnasBD, this.arregloColaboradores)
            .subscribe( (respuesta: colabInter.respuestaGuardaBD) => {
              if(respuesta.message == '230'){
                fin = new Date();
                let fx = (fin.getTime() - inicio.getTime()) / 1000;
                console.log("tiempo de guardado de bd en backend: "+fx+" segs");
                this.colaboradoresService.getColaboradoresFast(this.productoCertificar.idCertificar)
                .subscribe( (getFast: colabInter.getBDFast) => {
                  if(getFast.message == 'Success'){
                    this.deleteAttachment();
                    this.guardandoBD = false;
                    this.colabsEnBD = getFast.numeroColaboradores;
                    this.fechaCarga = getFast.fecha;

                    this.stored = true;
                    this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUARDADO'), 1);
                  }
                  else{
                    this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUA_ERR'), 3);
                  }
                });
              }
              else{
                this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.GUA_ERR'), 3);
              }
            });
          }
        });
      }
    }
    else{
      //mensaje swal
    }
  }

  borrarColaboradores(){
    if(!this.pasoCompleto){
      if(this.stored && this.colabsEnBD > 0 && this.fechaCarga){
        if(this.envioCorreo){
          Swal.fire({
            title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.NODELETE') ,
            icon: 'error',

            confirmButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.SI'),
          });

        }else{
          Swal.fire({
            title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DELETE_1') + this.colabsEnBD + this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DELETE_2'),
            icon: 'warning',
            showCancelButton: true,
reverseButtons: true,


            confirmButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.SI'),
            cancelButtonText: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.NO')
          }).then((result) => {
            if (result.value) {
              let inicio = new Date();
              let fin: any;
              this.colaboradoresService.borrarColaboradores(this.productoCertificar.idCertificar)
              .subscribe( (resultado: colabInter.respuestaEliminaBD) => {
                if(resultado.message == '231' && resultado.respuesta == this.colabsEnBD){
                  this.stored = false;
                  this.colabsEnBD = 0;
                  this.fechaCarga = null;
                  this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_1') + resultado.respuesta + this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_2'), 1);
                }
                else{
                  this.mensajeSwal(this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.DEL_ERR'), 3);
                }
              });
            }
          });

        }

      }
    }
    else{
      this.aletaRestric('COLABORADORES.RESTRICCION',null,'warning');
    }
  }

  descargaExcel(){
    Swal.fire({
      title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXCEL'),
      didOpen: () => {
        Swal.showLoading()
      }
    });
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.TITULO'),
      Subject: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.ASUNTO'),
      Author: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.AUTOR'),
      CreatedDate: new Date()
    };

    wb.SheetNames.push(this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.HOJA'));
    // var ws_data = [['hello' , 'world']];  //a row with 2 columns
    var ws_data = [];
    var columnaVacia=[];
    let nombresColumnas:string[] = [];

    // colabInter.CLAVES_COLUMNAS.forEach( (nombre) =>{
    //   nombresColumnas.push(nombre);
    // });
    // ws_data.push(nombresColumnas);

    this.colaboradoresService.getColaboradoresFull(this.productoCertificar.idCertificar).subscribe( (getFull: colabInter.getBDFull) => {
      if(getFull.message == 'Success' && getFull.bdcolaboradores.length > 0){
        colabInter.CLAVES_COLUMNAS.forEach( (nombre,i) =>{
          // nombresColumnas.push(nombre);

          if(getFull.columnas[nombre.clave]){
            nombresColumnas.push(getFull.columnas[nombre.clave]);
          }
          else{
            columnaVacia.push(i);
          }
        });
        // console.log(nombresColumnas);
        ws_data.push(nombresColumnas);

        getFull.bdcolaboradores.forEach( (colaborador) => {
          let datosColaboradores:any[] = [];
          colabInter.CLAVES_COLUMNAS.forEach( (nombre,i) => {

            if(!columnaVacia.includes(i)){
              if(colaborador[nombre.clave]){
                switch (colaborador[nombre.clave]) {
                  case 'antiquity': case 'enterDate':
                    datosColaboradores.push(this.fechaCorrecta(colaborador[nombre.clave]));
                  break;
                  default:
                    datosColaboradores.push(colaborador[nombre.clave].toString());
                  break;
                }
              }
              else{
                if(nombre.clave == 'bossKey'){
                  datosColaboradores.push('0');
                }
                else{
                  datosColaboradores.push('');
                }
              }
            }
          });
          // console.log(datosColaboradores);
          ws_data.push(datosColaboradores);
        });

        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.HOJA')] = ws;

        var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

        var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

        saveAs(new Blob([buf],{type:"application/octet-stream"}), this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.TITULO')+' - '+this.nombreEmpresa+'.xlsx');
        Swal.close();
      }
    });
  }

  completarPaso(){
    if(this.pasoCompleto){
      //this.aletaRestric('COLABORADORES.COMPLETADO',null,'warning');
      let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
      this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
      //this.alertaRestric2('IDIOMAS.COMPLETADO',null,'warning');
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: 'bottom',
        panelClass: ['background-red']
      });
    }
    else{
      if(this.stored && this.colabsEnBD > 0 && this.fechaCarga){
        this.aletaRestric('COLABORADORES.COMPLETAR',true);
      }
      else{
        this.aletaRestric('COLABORADORES.NADA',null,'warning');
      }
      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }

  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  desbloquearColaboradores(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.TITULO_DESBLOQUEAR';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'DescompletePasColab',
            productoId:this.productoCertificar.idCertificar,
            colaboradores: 2
          }
          console.log("Descompletar paso Colaboradores");
          this.colaboradoresService.DesbloquearPasoColaboradores(datos).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '211'){
               this.pasoCompleto = false;
               this.openSnackBar(succes,"OK");
               this.enviaOrdenWizard();
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,

               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,

        confirmButtonText: cerrar,
        })
      }
  }
  openSnackBar(message: string, action: string) {
    Swal.close();
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  sendUsers(){

    if(localStorage.getItem("tipoProducto") == "c1"){
      let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.ACTUALIZAR';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      let rspOk = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.OK';
      this.translateSrv.get(rspOk).subscribe((res: string) => { rspOk = res; });
      console.log('init sendUsers');

      let data = {
        productoId: localStorage.getItem('productoID')
      }
      this.encuestaService.saveUsuariosBD(data).subscribe((response:any) => {
        console.log('saveUsuarios:',response);
        if(response.success){
          let datos={
            accionText:'completePasColab',
            productoId:this.productoCertificar.idCertificar,
            colaboradores: 3
          }
          console.log("completar paso Colaboradores");
          this.colaboradoresService.guardaStatusColaboradores(datos).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '211'){
              //this.aletaRestric('COLABORADORES.'+data.message,null,'success');
              let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.210";
              this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
              this.openSnackBar(textoMensaje,"OK");
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
              Swal.close();
            };
          });
        }
      });
    }
    else{
      let datos={
        accionText:'completePasColab',
        productoId:this.productoCertificar.idCertificar,
        colaboradores: 3
      }
      console.log("completar paso Colaboradores");
      this.colaboradoresService.guardaStatusColaboradores(datos).subscribe( (data: backInter.RespuestaGen) => {
        if(data.message == '211'){
          //this.aletaRestric('COLABORADORES.'+data.message,null,'success');
          let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.210";
          this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
          this.openSnackBar(textoMensaje,"OK");
          this.pasoCompleto = true;
          this.enviaOrdenWizard();
          Swal.close();
        };
      });
    }

  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.TITULO'),
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
          this.sendUsers();
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
  }

  surveyCheckService(){
    if(this.token){
    this.programacionService.surveyCheck(this.token).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.datosSurveyCheck=respuesta.result;
      this.surveyCheck();
    }, error => {
    });
    }
  }

  surveyCheck(){
      const dialogRef = this.dialog.open(SurveyCheckComponent, {
        width: '40%',
        data: {
          datos: this.datosSurveyCheck
        }
      });
  }

}
